<template>
  <div class="house-locked-arrears">
    <div class="house-locked-arrears-item" v-if="monthTableData.length>0">
      <div class="house-locked-arrears-item-title">月度缴费</div>
      <div class="house-locked-arrears-item-body">
        <el-table :data="monthTableData" style="width: 100%" border>
          <el-table-column prop="name" label="指标" align="center" width="150" fixed></el-table-column>
          <el-table-column prop="m1" label="1月" align="center" width="100"></el-table-column>
          <el-table-column prop="m2" label="2月" align="center" width="100"></el-table-column>
          <el-table-column prop="m3" label="3月" align="center" width="100"></el-table-column>
          <el-table-column prop="m4" label="4月" align="center" width="100"></el-table-column>
          <el-table-column prop="m5" label="5月" align="center" width="100"></el-table-column>
          <el-table-column prop="m6" label="6月" align="center" width="100"></el-table-column>
          <el-table-column prop="m7" label="7月" align="center" width="100"></el-table-column>
          <el-table-column prop="m8" label="8月" align="center" width="100"></el-table-column>
          <el-table-column prop="m9" label="9月" align="center" width="100"></el-table-column>
          <el-table-column prop="m10" label="10月" align="center" width="100"></el-table-column>
          <el-table-column prop="m11" label="11月" align="center" width="100"></el-table-column>
          <el-table-column prop="m12" label="12月" align="center" width="100"></el-table-column>
          <el-table-column prop="y" label="年度累计" align="center" width="100"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="house-locked-arrears-item" v-if="quartTableData.length>0">
      <div class="house-locked-arrears-item-title">季度缴费</div>
      <div class="house-locked-arrears-item-body">
        <el-table :data="quartTableData" style="width: 100%" border>
          <el-table-column prop="name" label="指标" align="center" width="150" fixed></el-table-column>
          <el-table-column prop="q1" label="一季度" align="center">
            <el-table-column prop="m1" label="1月" align="center" width="100"></el-table-column>
            <el-table-column prop="m2" label="2月" align="center" width="100"></el-table-column>
            <el-table-column prop="m3" label="3月" align="center" width="100"></el-table-column>
            <el-table-column prop="q1" label="累计覆盖" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="q2" label="二季度" align="center">
            <el-table-column prop="m4" label="4月" align="center" width="100"></el-table-column>
            <el-table-column prop="m5" label="5月" align="center" width="100"></el-table-column>
            <el-table-column prop="m6" label="6月" align="center" width="100"></el-table-column>
            <el-table-column prop="q2" label="累计覆盖" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="q3" label="三季度" align="center">
            <el-table-column prop="m7" label="7月" align="center" width="100"></el-table-column>
            <el-table-column prop="m8" label="8月" align="center" width="100"></el-table-column>
            <el-table-column prop="m9" label="9月" align="center" width="100"></el-table-column>
            <el-table-column prop="q3" label="累计覆盖" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="q4" label="四季度" align="center">
            <el-table-column prop="m10" label="10月" align="center" width="100"></el-table-column>
            <el-table-column prop="m11" label="11月" align="center" width="100"></el-table-column>
            <el-table-column prop="m12" label="12月" align="center" width="100"></el-table-column>
            <el-table-column prop="q4" label="累计覆盖" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="y" label="年度累计" align="center" width="100"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="house-locked-arrears-item" v-if="halfTableData.length>0">
      <div class="house-locked-arrears-item-title">半年缴费</div>
      <div class="house-locked-arrears-item-body">
        <el-table :data="halfTableData" style="width: 100%" border>
          <el-table-column prop="name" label="指标" align="center" width="150" fixed></el-table-column>
          <el-table-column prop="h1" label="上半年" align="center">
            <el-table-column prop="m1" label="1月" align="center" width="100"></el-table-column>
            <el-table-column prop="m2" label="2月" align="center" width="100"></el-table-column>
            <el-table-column prop="m3" label="3月" align="center" width="100"></el-table-column>
            <el-table-column prop="m4" label="4月" align="center" width="100"></el-table-column>
            <el-table-column prop="m5" label="5月" align="center" width="100"></el-table-column>
            <el-table-column prop="m6" label="6月" align="center" width="100"></el-table-column>
            <el-table-column prop="h1" label="半年累计" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="h2" label="下半年" align="center">
            <el-table-column prop="m7" label="7月" align="center" width="100"></el-table-column>
            <el-table-column prop="m8" label="8月" align="center" width="100"></el-table-column>
            <el-table-column prop="m9" label="9月" align="center" width="100"></el-table-column>
            <el-table-column prop="m10" label="10月" align="center" width="100"></el-table-column>
            <el-table-column prop="m11" label="11月" align="center" width="100"></el-table-column>
            <el-table-column prop="m12" label="12月" align="center" width="100"></el-table-column>
            <el-table-column prop="h2" label="半年累计" align="center" width="100"></el-table-column>
          </el-table-column>
          <el-table-column prop="y" label="年度累计" align="center" width="100"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="house-locked-arrears-item" v-if="yearTableData.length>0">
      <div class="house-locked-arrears-item-title">年度催费</div>
      <div class="house-locked-arrears-item-body">
        <el-table :data="yearTableData" style="width: 100%" border>
          <el-table-column prop="name" label="指标" align="center" width="150" fixed></el-table-column>
          <el-table-column prop="m1" label="1月" align="center" width="100"></el-table-column>
          <el-table-column prop="m2" label="2月" align="center" width="100"></el-table-column>
          <el-table-column prop="m3" label="3月" align="center" width="100"></el-table-column>
          <el-table-column prop="m4" label="4月" align="center" width="100"></el-table-column>
          <el-table-column prop="m5" label="5月" align="center" width="100"></el-table-column>
          <el-table-column prop="m6" label="6月" align="center" width="100"></el-table-column>
          <el-table-column prop="m7" label="7月" align="center" width="100"></el-table-column>
          <el-table-column prop="m8" label="8月" align="center" width="100"></el-table-column>
          <el-table-column prop="m9" label="9月" align="center" width="100"></el-table-column>
          <el-table-column prop="m10" label="10月" align="center" width="100"></el-table-column>
          <el-table-column prop="m11" label="11月" align="center" width="100"></el-table-column>
          <el-table-column prop="m12" label="12月" align="center" width="100"></el-table-column>
          <el-table-column prop="y" label="年度累计" align="center" width="100"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "HouseLockedArrears",
  inject:['where','reginWhere'],
  data() {
    return {
      monthTableData: [],
      quartTableData: [],
      halfTableData: [],
      yearTableData: []
    }
  },
  mounted() {
    this.getHouseLockedArrearsAll();
  },
  methods: {
    getHouseLockedArrearsAll(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseLockedArrears/getHouseLockedArrearsAll",where,ret=>{
        if(ret.code){
          that.monthTableData = ret.data.monthTableData;
          that.quartTableData = ret.data.quartTableData;
          that.halfTableData = ret.data.halfTableData;
          that.yearTableData = ret.data.yearTableData;
        }
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.getHouseLockedArrearsAll();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.getHouseLockedArrearsAll();
      },500,that);
    },
    "reginWhere.project_ids":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.getHouseLockedArrearsAll();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.getHouseLockedArrearsAll();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.getHouseLockedArrearsAll();
      },500,that);
    },
  }
}
</script>

<style lang="scss" scoped>
.house-locked-arrears{
  display: flex;
  flex-direction: column;

  &-item {
    flex: 1;
    margin-bottom: 20px;

    &-title {
      font-size: 15px;
      font-weight: bold;
    }

    &-body {

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/HouseLockedArrears.vue